"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.Checkbox = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _label = _interopRequireDefault(require("@ingka/label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formField = require("@ingka/form-field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const propTypes = {
  id: _propTypes.string.isRequired,
  name: _propTypes.string,
  value: _propTypes.string.isRequired,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  onChange: _propTypes.func,
  disabled: _propTypes.bool,
  defaultChecked: _propTypes.bool,
  checked: _propTypes.bool,
  describedById: _propTypes.string,
  prefix: _propTypes.string,
  className: _propTypes.string,
  required: _propTypes.bool,
  subtle: _propTypes.bool,
  indeterminate: _propTypes.bool
};
exports.propTypes = propTypes;
const Checkbox = (0, _react.forwardRef)((props, publicRef) => {
  const {
    className,
    prefix = '',
    id,
    label,
    name = 'checkboxname',
    value,
    onChange,
    disabled = false,
    describedById,
    required,
    subtle = false,
    indeterminate,
    ...other
  } = props;
  const classes = (0, _classnames.default)(subtle && `${prefix}checkbox--subtle`, `${prefix}checkbox`, className);
  const {
    shouldValidate,
    valid
  } = (0, _react.useContext)(_formField.FormFieldContext);
  const checkboxRef = publicRef || _react.default.useRef(null);
  _react.default.useEffect(() => {
    if (typeof indeterminate !== 'undefined' && checkboxRef.current) {
      checkboxRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);
  return _react.default.createElement("span", {
    className: classes
  }, _react.default.createElement("input", _extends({
    ref: checkboxRef,
    type: "checkbox",
    value: value,
    name: name,
    id: id,
    disabled: disabled,
    onChange: onChange,
    "aria-describedby": describedById,
    required: required,
    "aria-invalid": shouldValidate ? !valid : null
  }, other)), _react.default.createElement("span", {
    className: `${prefix}checkbox__symbol`
  }), label && _react.default.createElement("span", {
    className: `${prefix}checkbox__label`
  }, _react.default.createElement(_label.default, {
    prefix: prefix,
    htmlFor: id,
    label: label
  })));
});
exports.Checkbox = Checkbox;
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports.default = _default;